<template>
    <div>
        <hemocir-button
            :title="$t('utils.add')"
            font-awesome-icon="fa-plus-circle"
            variant="outline-gray"
            @click="$bvModal.show(modalId)"
        />

        <b-modal :id="modalId" centered hide-footer size="lg">
            <template v-slot:modal-title>
                {{ $t('postSurgery.createPopup.title') | capitalize }}
            </template>
            <detail-surgery-add-element
                :date="dateWithoutTime"
                :surgery-id="surgeryId"
                :is-complication="isComplication"
                @close="$bvModal.hide(modalId)"
                @save="save"
                @select="hideModalClose=true"
            />
        </b-modal>
    </div>

</template>
<script>
    import DetailSurgeryAddElement from "@/components/surgery/detail/DetailSurgeryAddElement";

    export default {
        name: 'TimelineCreateGeneralItem',
        components: { DetailSurgeryAddElement},
        props: {
            date: {
                type: String,
                required: true,
            },
            surgeryId: {
                type: Number,
                required: true,
            },
            index: {
                type: [String, Number],
                required: true,
            },
            isComplication: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            modalId() {
                return 'create-element-modal' + this.index;
            },
            dateWithoutTime() {
                if (this.date.includes('T')) {
                    return this.date.split('T')[0];
                }
                return this.date;
            },
        },
        methods: {
            save() {
                this.$emit('save');
                this.$bvModal.hide(this.modalId);
            }
        },
    };
</script>
